import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import emailIcon from "../images/icons/email.svg";
import phoneIcon from "../images/icons/phone.svg";
import markerIcon from "../images/icons/marker.svg";
import "../styles/components/Footer.css";

const Footer = () => {
  return (
    <footer>
      <Container>
        <div className="top">
          <Row style={{ marginBottom: "25px" }}>
            <Col xs={12} sm={12} md={6} lg={6} className="third_part">
              <h2>ASSKMIND</h2>
              <p>
                ASSKMIND will work to meet your business needs, solve your
                technical dilemmas and provide the information you need to stay
                ahead of the competition.
              </p>
            </Col>
            <Col xs={12} sm={12} md={3} lg={3} className="second_part">
              <h2>Products</h2>
              <ul>
                <li>
                  <a
                    href="https://muktvendings.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Mukt Vendings
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    //target="_blank"
                    //rel="noopener noreferrer"
                    onClick={() =>
                      alert("This page is under construction, coming soon!")
                    }
                  >
                    Motelians
                  </a>
                </li>
                <li>
                  <a
                    href="https://grabmyfoods.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    MMO (Make My Order)
                  </a>
                </li>
              </ul>
            </Col>
            <Col xs={12} sm={12} md={3} lg={3} className="first_part">
              <h2>Contact Info</h2>
              <ul>
                <li>
                  <a href="mailto:hr@asskmind.com">
                    <img src={emailIcon} alt="Email Icon" /> hr@asskmind.com
                  </a>
                </li>
                <li style={{ marginRight: "25px" }}>
                  <a
                    href="https://wa.me/18204440552"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={phoneIcon} alt="Phone Icon" /> +1 (820) 444 0552
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.google.com/maps/place/830+E+Higgins+Rd,+Schaumburg,+IL+60173/@42.0414863,-88.060969,16z/data=!3m1!4b1!4m6!3m5!1s0x880faf0d29903701:0x5984844faefd7315!8m2!3d42.0414823!4d-88.0583887!16s%2Fg%2F11bw3xb_8r?entry=ttu&g_ep=EgoyMDI2MDMyMy4xIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={markerIcon} alt="Marker Icon" />
                    <span>
                      830 E Higgins Rd, Suite 104 F,
                      <br />
                      Schaumburg, IL 60173
                    </span>
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
        <hr />
        <div className="bottom">
          <p>© 2025 ASSKMIND | All Rights Reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
